module.exports = __webpack_public_path__ + "static/step_note_mission_card-f08ed8afa0f17e36c10f3817961ac8be.svg";